import { CreateAccreditationDTO, EditAccreditationDTO, AccreditationDTO } from './accreditation-profile.dto';
import { RootState } from '../../../../store/reducers';

export const selectCurrentAccreditation = (
  state: RootState,
): CreateAccreditationDTO | EditAccreditationDTO | AccreditationDTO => state.rankings.currentAccreditation;
